import { SVGProps } from 'react';

export default function BurgerMenu(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none" preserveAspectRatio='none' {...props}>
      <path d="M10.5 59.5C10.5 61.433 12.067 63 14 63H70C71.933 63 73.5 61.433 73.5 59.5C73.5 57.567 71.933 56 70 56H14C12.067 56 10.5 57.567 10.5 59.5ZM10.5 42C10.5 43.933 12.067 45.5 14 45.5H70C71.933 45.5 73.5 43.933 73.5 42C73.5 40.067 71.933 38.5 70 38.5H42H14C12.067 38.5 10.5 40.067 10.5 42ZM14 21C12.067 21 10.5 22.567 10.5 24.5C10.5 26.433 12.067 28 14 28H70C71.933 28 73.5 26.433 73.5 24.5C73.5 22.567 71.933 21 70 21H14Z" />
    </svg>
  )
}